"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaFromFormData = void 0;
const slim_1 = require("@blockprotocol/type-system/slim");
const getSchemaFromFormData = (data) => {
    const properties = data.properties;
    const schemaProperties = {};
    const required = [];
    for (const property of properties) {
        const propertyKey = (0, slim_1.extractBaseUrl)(property.$id);
        if (typeof property.minValue === "string" ||
            typeof property.maxValue === "string") {
            throw new Error("Invalid property constraint");
        }
        const prop = property.array
            ? {
                type: "array",
                minItems: property.minValue,
                items: { $ref: property.$id },
                ...(property.infinity ? {} : { maxItems: property.maxValue }),
            }
            : { $ref: property.$id };
        schemaProperties[propertyKey] = prop;
        if (property.required) {
            required.push((0, slim_1.extractBaseUrl)(property.$id));
        }
    }
    const links = {};
    for (const link of data.links) {
        if (typeof link.minValue === "string" ||
            typeof link.maxValue === "string") {
            throw new Error("Invalid property constraint");
        }
        links[link.$id] = {
            type: "array",
            minItems: link.minValue,
            ...(link.infinity ? {} : { maxItems: link.maxValue }),
            ordered: false,
            items: link.entityTypes.length
                ? {
                    oneOf: link.entityTypes.map((id) => ({ $ref: id })), // assert that there is at least one item in the array
                }
                : {},
        };
    }
    return {
        properties: schemaProperties,
        links,
        required,
    };
};
exports.getSchemaFromFormData = getSchemaFromFormData;
